<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card :loading="!loaded">
          <v-card-title>
            Facturas
            <v-icon style="margin-left: 0.25em" v-on:click="getData">mdi-reload</v-icon>
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar factura"
                single-line
                hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
              :headers="headers"
              :items="invoices"
              :search="search">
            <template v-slot:item.invoiceNumber="{item}">
              <p v-if="item.invoiceNumber<10"> 0000000{{ item.invoiceNumber }}/{{ item.date_add.split("-")[0] }}</p>
              <p v-if="item.invoiceNumber<100 && item.invoiceNumber>=10">
                000000{{ item.invoiceNumber }}/{{ item.date_add.split("-")[0] }}</p>
              <p v-if="item.invoiceNumber<1000 && item.invoiceNumber>=109">
                00000{{ item.invoiceNumber }}/{{ item.date_add.split("-")[0] }}</p>
            </template>
            <template v-slot:item.socialName="{item}">

              <router-link :to="'/clientdata/'+item.userID" class="clientLink">{{ item.socialName }}</router-link>

            </template>

            <template v-slot:item.total="{item}">
              <b>{{ getParseTotal(item.total) }}€</b>

            </template>
            <template v-slot:item.status="{item}">
              <span v-if="item.status==='0'" style="color:#E8AD00">Pendiente de pago</span>
              <span v-else-if="item.status==='1'" style="color:#217A2B">Pagada</span>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                  v-if="item.status==='0'"
                  color="green lighten-3"
                  class="ma-2 white--text"
                  outlined
                  @click="setPaidInvoice(item.invoiceID)">
                Marcar Pagada
                <v-icon right dark>mdi-check</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.PDF="{ item }">
              <a :href="'https://invoicer.grupowapps.es/generator/invoice/'+item.invoiceID+'/'+item.userID"
                 target="_blank" rel="nofollow">
                <v-icon>mdi-text-box-multiple-outline</v-icon>
              </a>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Invoices",
  data() {
    return {
      invoices: [],
      headers: [
        {
          text: 'Factura Nº',
          align: 'start',
          sortable: false,
          value: 'invoiceNumber',
        },
        {text: 'Cliente', value: 'socialName',sortable: false},
        {text: 'Descripción', value: 'name',sortable: false},
        {text: 'Fecha Emisión', value: 'date_add',sortable: false},
        {text: 'Total', value: 'total',sortable: false},
        {text: 'Estado', value: 'status'},
        {text: 'Acciones', value: 'action', sortable: false},
        {text: 'Ver PDF', value: 'PDF', sortable: false}
      ],
      search: '',
      loaded: false
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loaded = false;
      let url = this.base_url + '/invV2/admin/facturas/' + localStorage.token;
      this.axios.get(url).then(response => {
        this.invoices = response.data.invoices;
        this.loaded = true;
      });
    },
    getParseTotal(total){
      return parseFloat(total).toFixed(2)
    },
    setPaidInvoice(iid) {
      this.loaded = false;
      let url = this.base_url + '/invV2/admin/pagarfactura';
      let formData = new FormData();
      formData.set('token', localStorage.token);
      formData.set('iid', iid);
      this.axios.post(url, formData).then(() => {
        this.getData();
      })
    }
  }
}
</script>

<style scoped>
.clientLink {
  text-decoration: none;
  color: black;
  font-weight: bold;
}

.clientLink:hover {
  color: #90CAF9 !important;
}
</style>